import { cloneTexture2D } from '../texture/texture-2d.js';

const ext = {
  id: "KHR_texture_transform",
  wrapTexture(tex, texInfo) {
    const info = texInfo;
    if (!info) {
      return tex;
    }
    const kt = info.extensions?.KHR_texture_transform;
    const patch = {};
    if (kt) {
      if (kt.scale) {
        patch.uScale = kt.scale[0];
        patch.vScale = kt.scale[1];
      }
      if (kt.offset) {
        patch.uOffset = kt.offset[0];
        patch.vOffset = kt.offset[1];
      }
      if (kt.rotation) {
        patch.uAng = kt.rotation;
      }
      if (Object.keys(patch).length) {
        patch._hasTx = true;
      }
    }
    const tc = kt?.texCoord ?? info.texCoord;
    if (tc === 1) {
      patch._texCoord = 1;
    }
    return Object.keys(patch).length ? cloneTexture2D(tex, patch) : tex;
  }
};

export { ext as default };
//# sourceMappingURL=gltf-ext-uv-transform.js.map
